import Footer from "./item/footer";
import Header from "./item/header";
import Subtitle from "./item/header/subtitle";
import Title from "./item/header/title";
import Wrapper from "./item/wrapper";
import { FullScreen, Large, Medium, Small, XSmall } from "./modal";

export default {
  XSmall,
  Small,
  Medium,
  Large,
  FullScreen,
  Item: { Header, Wrapper, Title, Subtitle, Footer },
};
